/** SHA-256 hash a PIN string → 64-char lowercase hex. Uses built-in Web Crypto. */
export async function hashPin(pin) {
  const buf = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(String(pin))
  );
  return Array.from(new Uint8Array(buf))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

/** Return true if the string looks like a raw PIN (≤6 digits), not a hash. */
export function isPlainPin(value) {
  return typeof value === 'string' && /^\d{4,6}$/.test(value);
}
